import React, { Component } from 'react';
import CubeContainer from './CubeContainer';

class App extends Component {
      
    // handlerArgCall = () => {
    //     new CubeContainer().functionWithArg("Eureka!");
    // };
    
    render() {
        return (
            <div>
                <div className="app">
                    <CubeContainer />
                    {/* <div style={{"position": "absolute", "top": 330 + "px","z-index": 9999999}}>
                        <button onClick={this.handlerArgCall.bind(this)}>Click me</button>
                    </div> */}
                </div>

            </div>
        );
    }

}

export default App;




// WEBPACK FOOTER //
// ./src/components/App.js